export const INN12_WARNING_MESSAGE = "Некорректный ИНН";

export function validateInn12(raw: string) {
  if (typeof raw !== 'string') return false;

  const digits = raw.replace(/\D/g, '');
  if (digits.length !== 12) return false;

  if (digits === '000000000000') {
    return false;
  }

  const digitArray = digits.split('').map(Number);
  const w11 = [7, 2, 4, 10, 3, 5, 9, 4, 6, 8, 0];     // для 11-й (предпоследней) цифры
  const w12 = [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8, 0];  // для 12-й (последней) цифры

  const n11 = w11.reduce((acc, w, i) => acc + digitArray[i] * w, 0) % 11 % 10;
  const n12 = w12.reduce((acc, w, i) => acc + digitArray[i] * w, 0) % 11 % 10;

  return n11 === digitArray[10] && n12 === digitArray[11];
}
